import Input from "./Input/Input";
import InputRut from "./InputRut/InputRut";
import InputEmail from "./InputEmail/InputEmail";
import InputPhone from "./InputPhone/InputPhone";
import CardDate from "./CardDate/CardDate";
import CurrencyInput from "./CurrencyInput/CurrencyInput";
import Loading from "./Loading/Loading";

var fullName = function fullName(user) {
  if (!user) return "-";
  if (user.full_name) return user.full_name;
  if (user.name.includes(" ")) return user.name;
  return "".concat(user.name).concat(user.middle_name ? " " + user.middle_name : "").concat(user.first_surname ? " " + user.first_surname : "").concat(user.second_surname ? " " + user.second_surname : "");
};

export { Input, InputRut, InputEmail, InputPhone, CardDate, CurrencyInput, Loading, fullName };